import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addToFavorites, deleteFromFavorites } from '../../store/favorites/actions';
import { dateFormation } from '../../services/utils';
import { channelListForCards as channelList } from '../../services/constants';

import {
  BookmarkSt,
  CardSt,
  ImgSt,
  LinkSt,
  LabelSt,
  TextSt,
  DateSt,
  ButtonSt,
  CenterSvgSt,
  ContainerFormSt,
  СhoosePictureContainerSt,
  FormСhooseSt,
  DiscriptionSt,
  OpenDiscriptionSt,
  CrossSt,
  TitleSt,
  DiscriptionContainerSt,
  DiscriptionContentSt,
  ProjectTextSt,
  ProjectDiscriptionSt,
  HrSt,
  FooterSt,
  FooterContentSt,
  FooterContainerSt,
  FooterContentASt,
  CardMarginRightSt,
  LabelWrapperSt,
  WrapperBookmarkSt,
  ChooseCardTopSt,
  LinkTitleSt,
  DiscriptionChannelSVGSt,
} from './style';

import i18n from 'i18next';

const CARD_CLOSED = ['width: 0; height: 0; z-index: 1;', 'opacity: 0', 'opacity: 0'];
const CARD_OPENED = ['width: 138%; height: 100%; z-index: 11;', 'opacity: 1; transition: opacity .2s .5s;', 'opacity: .7; transition: opacity .3s .5s;'];

const Card = (props) => {
  const {
    date_start, date_end, genres, page, type, zIndexCard, widthCard, id, title, slug,
    poster_en, poster_ru, discriptionOpenLeft, year_start, year_end, category, duration,
    channel, description, age_restriction, trailer_embed, handleClick,
    isInFavourites, is_requested, index,
    chooseCard: chooseCardProp, closeAllCardsDiscription,
    _getallchooseCard, _openDecrStepRight, _closeAllCardsDiscription,
  } = props;

  const [openCardControl, setOpenCardControl] = useState(['width: 0; height: 0; z-index: 1;', 'opacity: 0;', 'opacity: 0']);
  const [openCard, setOpenCard] = useState(false);
  const [exceptionFromLastCard, setExceptionFromLastCard] = useState(false);
  const [chooseCard, setChooseCard] = useState(false);
  const [bookmarkCheck, setBookmarkCheck] = useState((page === 'favorites' || isInFavourites) ? true : false);
  const [cardHiddenOnFavourites, setCardHiddenOnFavourites] = useState(false);
  const [isRequested, setIsRequested] = useState(
    (page === 'favorites' || page === 'collections' || page === 'collection') && is_requested
  );

  const dispatch = useDispatch();
  const token = useSelector((store) => store.auth.dataToken.token);
  const isLoggedIn = useSelector((store) => store.auth.isLoggedIn);
  const favoritesProject = useSelector((store) => store.favorites.project);
  const favoritesMessage = useSelector((store) => store.favorites.message);

  const timers = useRef([]);
  useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

  // Закрытие описания каточки проектов
  const closeCard = () => {
    setOpenCardControl(CARD_CLOSED);
    if (discriptionOpenLeft) {
      setExceptionFromLastCard(false);
    }
  };

  // componentDidUpdate: реакция на изменения пропсов и стора
  const prevProps = useRef(null);
  // намеренно без списка зависимостей — это перенос componentDidUpdate
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const prev = prevProps.current;
    prevProps.current = { chooseCardProp, closeAllCardsDiscription, favoritesProject, favoritesMessage };

    if (!prev) return;

    // при выборе "выбрать все" закрываем открытое описание
    if (chooseCardProp !== prev.chooseCardProp && prev.chooseCardProp === false) {
      _getallchooseCard(id, 'addAll', page === 'favorites' && type);
      closeCard();
      setChooseCard(true);
    }
    else if (chooseCardProp !== prev.chooseCardProp && prev.chooseCardProp === true) {
      _getallchooseCard(id, 'removeAll', page === 'favorites' && type);
      setChooseCard(false);
    }
    // при открытии второго описания закрываем первое
    if (closeAllCardsDiscription !== prev.closeAllCardsDiscription) {
      setExceptionFromLastCard(false);
      setOpenCardControl(CARD_CLOSED);
    }

    if (favoritesProject !== prev.favoritesProject) {
      favoritesProject.forEach((item) => {
        if (item.id === id) {
          setBookmarkCheck(true);
          setChooseCard(false);
        }
      });
    }
    // если отправлен запрос на контент проекта, то проставляется галка об этом
    if (favoritesMessage !== prev.favoritesMessage) {
      favoritesMessage && favoritesMessage[1] && favoritesMessage[1].added && favoritesMessage[1].added.forEach((item) => {
        if (item === id) {
          setIsRequested(page === 'favorites' || page === 'collections' || page === 'collection');
        }
      });
    }
  });

  // Открытие описания каточки проектов
  const onOpenCard = () => {
    setOpenCard(true);
    if (!discriptionOpenLeft && _openDecrStepRight) {
      _openDecrStepRight(index);
    }
    if (_closeAllCardsDiscription) _closeAllCardsDiscription(); // закрываем второе описание если оно открыто
    timers.current.push(setTimeout(() => {
      setOpenCardControl(CARD_OPENED);
      if (discriptionOpenLeft) {
        setExceptionFromLastCard(true);
      }
    }, 100));
  };

  // выбрать карту/снять выбор карты
  const onChooseCard = () => {
    chooseCard
      ? _getallchooseCard(id, 'remove', page === 'favorites' && type)
      : _getallchooseCard(id, 'add', page === 'favorites' && type);
    closeCard();
    setChooseCard((prev) => !prev);
  };

  // обработка клика на закладку
  const _bookmark = (ids, favType) => {
    if (bookmarkCheck) {
      dispatch(deleteFromFavorites(ids, favType, token));
    } else {
      dispatch(addToFavorites(ids, favType, token));
    }
    setBookmarkCheck((prev) => !prev);
    if (page === 'favorites') {
      setCardHiddenOnFavourites(true);
    }
  };

  // после клика по карте, при переходе на страницу проекта, поднимаемся в самый верх экрана
  const _clickTop = () => {
    window.scrollTo(0, 0);
  };

  // Получение списка с жанрами
  let genresList = '';
  if (genres) {
    genresList = genres.map((item, i) => {
      return ((i !== 0 ? ', ' : '') + item.title);
    });
  }

  // проверка необходимости чекбоксов и связанных сними элеменетов верстки
  const checkbox = token && (page === 'collections' || (page === 'favorites' && type !== 'events')) && isLoggedIn;

  // ссылка на проект, мероприятие или коллекцию в зависимости от значения type
  // если значение type === "collections", то используется id, в противном случае slug
  const link = `/${type}/` + (type === 'collections' ? id : slug);

  return (
    <>
      <CardSt zIndexCard={zIndexCard} exceptionFromLastCard={exceptionFromLastCard} widthCard={widthCard} style={cardHiddenOnFavourites ? { display: "none" } : { display: "block" }}>

        {isLoggedIn && (
          <WrapperBookmarkSt chooseCard={checkbox}>
            {/* ЗАКЛАДКИ */}
            <BookmarkSt onClick={() => _bookmark([id], type)} isOpacity={bookmarkCheck} chooseCard={checkbox}>
              <div style={checkbox ? { marginLeft: '4px', position: 'relative', height: '100%' } : { position: 'relative', height: '100%' }}>
                {bookmarkCheck ?
                  (page === 'favorites' ?
                    <CenterSvgSt width="12" height="14" viewBox="0 -1 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z" fill="white" /></CenterSvgSt>
                    : <CenterSvgSt width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 0.25H2.25C1.425 0.25 0.75 0.925 0.75 1.75V13.75L6 11.5L11.25 13.75V1.75C11.25 0.925 10.575 0.25 9.75 0.25Z" fill="white" /></CenterSvgSt>)
                  : <CenterSvgSt width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 0.25H2.25C1.425 0.25 0.75 0.925 0.75 1.75V13.75L6 11.5L11.25 13.75V1.75C11.25 0.925 10.575 0.25 9.75 0.25ZM9.75 11.5L6 9.865L2.25 11.5V1.75H9.75V11.5Z" fill="white" /></CenterSvgSt>}
              </div>
            </BookmarkSt>
            {/* ПРОЕКТЫ - чекбокс "выбрать" */}
            {token && (page === 'collections' || (page === 'favorites' && type !== 'events')) && isLoggedIn && !isRequested &&
              <ContainerFormSt chooseCard={chooseCard}>
                <СhoosePictureContainerSt>
                  {!chooseCard && <CenterSvgSt width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.25 4.25V14.75H3.75V4.25H14.25ZM14.25 2.75H3.75C2.925 2.75 2.25 3.425 2.25 4.25V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V4.25C15.75 3.425 15.075 2.75 14.25 2.75Z" fill="white" />
                  </CenterSvgSt>}
                  {chooseCard && <CenterSvgSt width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.25 2.75H3.75C2.925 2.75 2.25 3.425 2.25 4.25V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V4.25C15.75 3.425 15.075 2.75 14.25 2.75ZM14.25 14.75H3.75V4.25H14.25V14.75ZM13.4925 7.25L12.435 6.185L7.4925 11.1275L5.5575 9.2L4.4925 10.2575L7.4925 13.25L13.4925 7.25Z" fill="white" />
                  </CenterSvgSt>}
                </СhoosePictureContainerSt>
                <FormСhooseSt>
                  <input type="checkbox" onChange={() => onChooseCard()} />
                </FormСhooseSt>
              </ContainerFormSt>}
            {isRequested && <ContainerFormSt style={{ background: 'rgb(49,57,78,1)' }}>
              <СhoosePictureContainerSt>
                <CenterSvgSt width="18" height="19" viewBox="0 4 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.00003 16.1698L4.83003 11.9998L3.41003 13.4098L9.00003 18.9998L21 6.99984L19.59 5.58984L9.00003 16.1698Z" fill="white" />
                </CenterSvgSt>
              </СhoosePictureContainerSt>
            </ContainerFormSt>}
          </WrapperBookmarkSt>
        )}

        <CardMarginRightSt>
          <LinkSt to={link} onClick={() => _clickTop()}>

            <ImgSt src={(i18n.language === 'en') ? (poster_en === '' ? '../img-test/default-card-img.jpg' : poster_en) : (poster_ru === "" ? "../img-test/default-card-img.jpg" : poster_ru)}></ImgSt>
            {/* КОЛЛЕКЦИИ */}
            {type === 'collections' && ``/*<LabelWrapperSt type={type} backgroundColor={zIndexCard}></LabelWrapperSt>*/}

            {/* ВЫСТАВКИ */}
            {type === 'events' &&
              <LabelWrapperSt type={type}>
                <LabelSt type={type}>
                  <TextSt>{title}</TextSt>
                </LabelSt>
                <DateSt>
                  <TextSt>
                    {dateFormation(date_start, date_end)}
                  </TextSt>
                </DateSt>
              </LabelWrapperSt>}
          </LinkSt>

          {(chooseCard && type !== 'events') && <ChooseCardTopSt></ChooseCardTopSt>}

          {/* ПРОЕКТЫ */}
          {type === 'catalog'
            && <ButtonSt chooseCard={chooseCard}>
              <CenterSvgSt width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.667967 12.0997L5.81866 6.99967L0.667968 1.89967L2.25366 0.333008L9.0013 6.99967L2.25366 13.6663L0.667967 12.0997Z" fill="white" />
              </CenterSvgSt>
              {!chooseCard && <OpenDiscriptionSt onClick={() => onOpenCard()}></OpenDiscriptionSt>}
            </ButtonSt>}

          {/* ПРОЕКТЫ - описание */}
          {type === 'catalog' && <DiscriptionSt openCardControl={openCardControl} discriptionOpenLeft={discriptionOpenLeft}>
            <DiscriptionContainerSt openCardControl={openCardControl}>
              {openCard && <DiscriptionContentSt>
                <LinkTitleSt to={link} onClick={() => _clickTop()} >
                  <TitleSt>{title}</TitleSt>
                </LinkTitleSt>
                <ProjectTextSt>{category && category.title + (genresList.length > 0 ? ', ' : '')}{genresList}</ProjectTextSt>
                <ProjectTextSt>{i18n.t(`card.production_year`)}: {year_start}{!year_end ? ' — ...' : year_end === year_start ? '' : (' — ' + year_end)}</ProjectTextSt>
                <ProjectTextSt>{i18n.t(`card.timing`)}: {duration}</ProjectTextSt>
                <HrSt></HrSt>
                <ProjectDiscriptionSt dangerouslySetInnerHTML={{ __html: `${description}` }}></ProjectDiscriptionSt>
              </DiscriptionContentSt>}
              <FooterSt>
                <FooterContainerSt>
                  <FooterContentSt paddingRight>
                    {channel && <DiscriptionChannelSVGSt width={channelList[channel.id] && channelList[channel.id].width} height={channelList[channel.id] && channelList[channel.id].height}>
                      <use xlinkHref={`images/logos-sprite.svg#${channelList[channel.id] && channelList[channel.id].img}`}></use>
                    </DiscriptionChannelSVGSt>}
                  </FooterContentSt>
                  <FooterContentSt>
                    {age_restriction && (age_restriction + " +")}
                  </FooterContentSt>
                </FooterContainerSt>
                {trailer_embed && <FooterContentASt href={trailer_embed} target="_blank" onClick={handleClick ? (evt) => handleClick(evt, trailer_embed) : null} >
                  <FooterContentSt paddingRight>
                    {i18n.t(`card.trailer`)}
                  </FooterContentSt>
                  <FooterContentSt>
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="13" cy="13" r="12" stroke="white" />
                      <path d="M17.375 13.3125L11.125 17.375L11.125 9.25L17.375 13.3125Z" fill="white" />
                    </svg>
                  </FooterContentSt>
                </FooterContentASt>}
              </FooterSt>
            </DiscriptionContainerSt>
            <CrossSt openCardControl={openCardControl}>
              <CenterSvgSt width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.59 14L14 12.59L8.41 7L14 1.41L12.59 -6.1633e-08L7 5.59L1.41 -5.50326e-07L-6.1633e-08 1.41L5.59 7L-5.50326e-07 12.59L1.41 14L7 8.41L12.59 14Z" fill="#42A5F5" />
              </CenterSvgSt>
              <OpenDiscriptionSt onClick={() => closeCard()}></OpenDiscriptionSt>
            </CrossSt>
          </DiscriptionSt>}

        </CardMarginRightSt>
      </CardSt>
    </>
  );
};

export default Card;
